/* eslint-disable @typescript-eslint/naming-convention */
import { Theme, PartialTheme } from './Theme';
export { ISchemeNames, IScheme } from './IScheme';

/**
 * {@docCategory ITheme}
 */
export interface ITheme extends Theme {}

/**
 * {@docCategory ITheme}
 */
export interface IPartialTheme extends PartialTheme {}
